// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SmKICH3wtiGE8HknviR4 {
  width: 100%;
  max-width: 1218px;
  display: flex;
  flex-direction: column;
  background-color: #1c1c1e;
  border: 1px solid #272727;
  border-radius: 10px;
  align-items: center;
  margin-bottom: 10px;
  box-shadow: 0 0 1px 1px #000;
}
.i6Aa0edHSazCvH2vFJPz {
  --tabs-padding: 6px;
  --tabs-gap: 1px;
  --tab-width: 189px;
  /* How far the row advances from one tab to the next. The tabs are laid out by \`space-between\`,
     so the spacing between two of them is whatever is left over, split across the gaps. */
  --tab-step: calc(var(--tab-width) + (100% - 2 * var(--tabs-padding) - var(--tab-count) * var(--tab-width)) / var(--tab-gaps));
  font-family: var(--font-family-primary);
  display: flex;
  position: relative;
  width: 100%;
  max-width: var(--campaign-tab-width);
  height: 54px;
  padding: var(--tabs-padding);
  margin: 12px 0;
  border-radius: 15px;
  justify-content: space-between;
  align-items: center;
  scrollbar-width: none;
  background-color: #101012;
  gap: var(--tabs-gap);
  color: #acacac;
}
.i6Aa0edHSazCvH2vFJPz[data-tab-count='3'] {
  --tab-width: 207px;
}
.A58jFRHAuRiIZYEBs9oc {
  display: flex;
  flex: 0 0 var(--tab-width);
  height: 42px;
  font-size: 21px;
  align-items: center;
  text-align: center;
  justify-content: center;
  cursor: pointer;
  z-index: 1;
}
.kPMZQeLdZQVm8yYhW9SU {
  color: white;
  font-weight: 450;
}
.qx5UFktx7czYid0xPEeQ {
  position: absolute;
  left: calc(var(--tabs-padding) + var(--active-tab-index) * var(--tab-step));
  width: var(--tab-width);
  height: 42px;
  background: #323334;
  border-radius: 12px;
  box-shadow: 0px 1px 0px 0px #434343 inset;
  transition: left 0.5s cubic-bezier(0.4, 0, 0.2, 1);
  z-index: 0;
}
@media (orientation: portrait) {
  .SmKICH3wtiGE8HknviR4 {
    width: 100%;
    padding: 0 6px;
    border-radius: 10px;
  }
  .i6Aa0edHSazCvH2vFJPz {
    border-radius: 10px;
  }
}
@media (max-width: 1024px),(min-width: 768px) and (max-width: 1024px) and (orientation: landscape),(orientation: portrait) {
  .i6Aa0edHSazCvH2vFJPz {
    --tabs-padding: 4px;
    border-radius: 10px;
    margin: 8px;
  }
  .A58jFRHAuRiIZYEBs9oc {
    font-size: 14px;
  }
  .kPMZQeLdZQVm8yYhW9SU {
    border-radius: 8px;
  }
}
@media (max-width: 1024px),(min-width: 768px) and (max-width: 1024px) and (orientation: landscape),(orientation: portrait) {
@media (max-color:2147477350) and (orientation: landscape) {
  .i6Aa0edHSazCvH2vFJPz {
    --tab-width: 126px;
    height: 36px;
  }
  .i6Aa0edHSazCvH2vFJPz[data-tab-count='3'] {
    --tab-width: 138px;
  }
  .A58jFRHAuRiIZYEBs9oc {
    height: 28px;
  }
  .qx5UFktx7czYid0xPEeQ {
    height: 28px;
    border-radius: 8px;
  }
}
}
@media not all and (orientation: portrait) {
@media not all and ( (min-width: 768px) and (max-width: 1024px) and (orientation: landscape)) {
@media not all and (max-width: 1024px) {
@media (color:2147477350) and (orientation: landscape) {
  .i6Aa0edHSazCvH2vFJPz {
    --tab-width: 126px;
    height: 36px;
  }
  .i6Aa0edHSazCvH2vFJPz[data-tab-count='3'] {
    --tab-width: 138px;
  }
  .A58jFRHAuRiIZYEBs9oc {
    height: 28px;
  }
  .qx5UFktx7czYid0xPEeQ {
    height: 28px;
    border-radius: 8px;
  }
}
}
}
}
@media (max-width: 1024px),(min-width: 768px) and (max-width: 1024px) and (orientation: landscape),(orientation: portrait) {
@media (max-color:2147477350) and (orientation: portrait) {
  /* Portrait has no fixed design width — the tabs share the row evenly. */
  .i6Aa0edHSazCvH2vFJPz,
  .i6Aa0edHSazCvH2vFJPz[data-tab-count='3'] {
    --tab-width: calc((100% - 2 * var(--tabs-padding) - var(--tab-gaps) * var(--tabs-gap)) / var(--tab-count));
    height: 40px;
  }
  .A58jFRHAuRiIZYEBs9oc {
    flex: 1;
    height: 32px;
  }
  .qx5UFktx7czYid0xPEeQ {
    height: 32px;
    border-radius: 8px;
  }
}
}
@media not all and (orientation: portrait) {
@media not all and ( (min-width: 768px) and (max-width: 1024px) and (orientation: landscape)) {
@media not all and (max-width: 1024px) {
@media (color:2147477350) and (orientation: portrait) {
  /* Portrait has no fixed design width — the tabs share the row evenly. */
  .i6Aa0edHSazCvH2vFJPz,
  .i6Aa0edHSazCvH2vFJPz[data-tab-count='3'] {
    --tab-width: calc((100% - 2 * var(--tabs-padding) - var(--tab-gaps) * var(--tabs-gap)) / var(--tab-count));
    height: 40px;
  }
  .A58jFRHAuRiIZYEBs9oc {
    flex: 1;
    height: 32px;
  }
  .qx5UFktx7czYid0xPEeQ {
    height: 32px;
    border-radius: 8px;
  }
}
}
}
}
`, "",{"version":3,"sources":["webpack://./src/features/campaigns/components/defaults/CampaignTabs/CampaignTabs.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,4BAA4B;AAC9B;AACA;EACE,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB;0FACwF;EACxF,6HAA6H;EAC7H,uCAAuC;EACvC,aAAa;EACb,kBAAkB;EAClB,WAAW;EACX,oCAAoC;EACpC,YAAY;EACZ,4BAA4B;EAC5B,cAAc;EACd,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,qBAAqB;EACrB,yBAAyB;EACzB,oBAAoB;EACpB,cAAc;AAChB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,0BAA0B;EAC1B,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;EACf,UAAU;AACZ;AACA;EACE,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,2EAA2E;EAC3E,uBAAuB;EACvB,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,yCAAyC;EACzC,kDAAkD;EAClD,UAAU;AACZ;AACA;EACE;IACE,WAAW;IACX,cAAc;IACd,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;AACF;AACA;EACE;IACE,mBAAmB;IACnB,mBAAmB;IACnB,WAAW;EACb;EACA;IACE,eAAe;EACjB;EACA;IACE,kBAAkB;EACpB;AACF;AACA;AAAA;EACE;IACE,kBAAkB;IAClB,YAAY;EACd;EACA;IACE,kBAAkB;EACpB;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;IACZ,kBAAkB;EACpB;AACF;AAAA;AAfA;AAAA;AAAA;AAAA;EACE;IACE,kBAAkB;IAClB,YAAY;EACd;EACA;IACE,kBAAkB;EACpB;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;IACZ,kBAAkB;EACpB;AACF;AAAA;AAAA;AAAA;AACA;AAAA;EACE,wEAAwE;EACxE;;IAEE,0GAA0G;IAC1G,YAAY;EACd;EACA;IACE,OAAO;IACP,YAAY;EACd;EACA;IACE,YAAY;IACZ,kBAAkB;EACpB;AACF;AAAA;AAfA;AAAA;AAAA;AAAA;EACE,wEAAwE;EACxE;;IAEE,0GAA0G;IAC1G,YAAY;EACd;EACA;IACE,OAAO;IACP,YAAY;EACd;EACA;IACE,YAAY;IACZ,kBAAkB;EACpB;AACF;AAAA;AAAA;AAAA","sourcesContent":[".campaignTabsContainer {\n  width: 100%;\n  max-width: 1218px;\n  display: flex;\n  flex-direction: column;\n  background-color: #1c1c1e;\n  border: 1px solid #272727;\n  border-radius: 10px;\n  align-items: center;\n  margin-bottom: 10px;\n  box-shadow: 0 0 1px 1px #000;\n}\n.tabsButtonContainer {\n  --tabs-padding: 6px;\n  --tabs-gap: 1px;\n  --tab-width: 189px;\n  /* How far the row advances from one tab to the next. The tabs are laid out by `space-between`,\n     so the spacing between two of them is whatever is left over, split across the gaps. */\n  --tab-step: calc(var(--tab-width) + (100% - 2 * var(--tabs-padding) - var(--tab-count) * var(--tab-width)) / var(--tab-gaps));\n  font-family: var(--font-family-primary);\n  display: flex;\n  position: relative;\n  width: 100%;\n  max-width: var(--campaign-tab-width);\n  height: 54px;\n  padding: var(--tabs-padding);\n  margin: 12px 0;\n  border-radius: 15px;\n  justify-content: space-between;\n  align-items: center;\n  scrollbar-width: none;\n  background-color: #101012;\n  gap: var(--tabs-gap);\n  color: #acacac;\n}\n.tabsButtonContainer[data-tab-count='3'] {\n  --tab-width: 207px;\n}\n.tabButton {\n  display: flex;\n  flex: 0 0 var(--tab-width);\n  height: 42px;\n  font-size: 21px;\n  align-items: center;\n  text-align: center;\n  justify-content: center;\n  cursor: pointer;\n  z-index: 1;\n}\n.activeTab {\n  color: white;\n  font-weight: 450;\n}\n.tabIndicator {\n  position: absolute;\n  left: calc(var(--tabs-padding) + var(--active-tab-index) * var(--tab-step));\n  width: var(--tab-width);\n  height: 42px;\n  background: #323334;\n  border-radius: 12px;\n  box-shadow: 0px 1px 0px 0px #434343 inset;\n  transition: left 0.5s cubic-bezier(0.4, 0, 0.2, 1);\n  z-index: 0;\n}\n@media (orientation: portrait) {\n  .campaignTabsContainer {\n    width: 100%;\n    padding: 0 6px;\n    border-radius: 10px;\n  }\n  .tabsButtonContainer {\n    border-radius: 10px;\n  }\n}\n@media (--campaign-mobile) {\n  .tabsButtonContainer {\n    --tabs-padding: 4px;\n    border-radius: 10px;\n    margin: 8px;\n  }\n  .tabButton {\n    font-size: 14px;\n  }\n  .activeTab {\n    border-radius: 8px;\n  }\n}\n@media (--campaign-mobile) and (orientation: landscape) {\n  .tabsButtonContainer {\n    --tab-width: 126px;\n    height: 36px;\n  }\n  .tabsButtonContainer[data-tab-count='3'] {\n    --tab-width: 138px;\n  }\n  .tabButton {\n    height: 28px;\n  }\n  .tabIndicator {\n    height: 28px;\n    border-radius: 8px;\n  }\n}\n@media (--campaign-mobile) and (orientation: portrait) {\n  /* Portrait has no fixed design width — the tabs share the row evenly. */\n  .tabsButtonContainer,\n  .tabsButtonContainer[data-tab-count='3'] {\n    --tab-width: calc((100% - 2 * var(--tabs-padding) - var(--tab-gaps) * var(--tabs-gap)) / var(--tab-count));\n    height: 40px;\n  }\n  .tabButton {\n    flex: 1;\n    height: 32px;\n  }\n  .tabIndicator {\n    height: 32px;\n    border-radius: 8px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"campaignTabsContainer": `SmKICH3wtiGE8HknviR4`,
	"tabsButtonContainer": `i6Aa0edHSazCvH2vFJPz`,
	"tabButton": `A58jFRHAuRiIZYEBs9oc`,
	"activeTab": `kPMZQeLdZQVm8yYhW9SU`,
	"tabIndicator": `qx5UFktx7czYid0xPEeQ`
};
export default ___CSS_LOADER_EXPORT___;
